import { useEffect, useState } from 'react';
import Label from '../label';
import styles from './styles.module.css';

type NameSwitcherProps = {
  id: string;
  name: string;
  value: string;
  labelActive: string;
  labelInactive: string;
  labelInactive2?: string;
  onChange: (name: string, value: string) => void;
  disabled?: boolean;
  className?: string;
  width?: string;
  fontSize?: number;
};

const DEFAULT_WIDTH = '170px';
const DEFAULT_FONT_SIZE = 16;

const NameSwitcher: React.FunctionComponent<NameSwitcherProps> = (props: NameSwitcherProps) => {
  const [labelActive, setLabelActive] = useState<string>(props.value);
  const [widthLabel, setWidthLabel] = useState<string>(props.width || DEFAULT_WIDTH);

  useEffect(() => {
    if (widthLabel !== props?.width && props?.width !== undefined) {
      setWidthLabel(props.width);
    }
  }, [props.width]);

  useEffect(() => {
    setLabelActive(props.value);
  }, [props.labelActive, props.value]);

  const onRadioChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const element = evt.target as HTMLInputElement;
    const value: string = element.dataset?.value || '';
    props.onChange(element.name, value);
  };

  const isFirstElementActive = labelActive === props.labelActive;
  const isSecondElementActive = labelActive === props.labelInactive;
  const isThirdElementActive = labelActive === props?.labelInactive2;

  return (
    <div className={styles['name-switcher-container']}>
      <input
        id={`label-active-${props.id}`}
        type="radio"
        name={props.name}
        data-value={props.labelActive}
        checked={isFirstElementActive}
        value="label-active"
        onChange={onRadioChange}
        className={styles['radio-button']}
        disabled={props.disabled}
      />
      <Label
        color={
          props.disabled
            ? 'var(--disabled-color)'
            : isFirstElementActive
              ? 'var(--primary-main-color)'
              : 'var(--main-font-color)'
        }
        htmlFor={`label-active-${props.id}`}
        disabled={props.disabled}
        width={widthLabel}
        fontSize={props?.fontSize || DEFAULT_FONT_SIZE}
      >
        {props.labelActive}
      </Label>
      <input
        id={`label-inactive-${props.id}`}
        type="radio"
        name={props.name}
        data-value={props.labelInactive}
        checked={isSecondElementActive}
        value="label-inactive"
        onChange={onRadioChange}
        className={styles['radio-button']}
        disabled={props.disabled}
      />
      <Label
        color={
          props.disabled
            ? 'var(--disabled-color)'
            : isSecondElementActive
              ? 'var(--primary-main-color)'
              : 'var(--main-font-color)'
        }
        htmlFor={`label-inactive-${props.id}`}
        disabled={props.disabled}
        width={widthLabel}
        fontSize={props?.fontSize || DEFAULT_FONT_SIZE}
      >
        {props.labelInactive}
      </Label>
      {props.labelInactive2 && (
        <>
          <input
            id={`label-inactive-2-${props.id}`}
            type="radio"
            name={props.name}
            data-value={props.labelInactive2}
            checked={isThirdElementActive}
            value="label-inactive-2"
            onChange={onRadioChange}
            className={styles['radio-button']}
            disabled={props.disabled}
          />
          <Label
            color={
              props.disabled
                ? 'var(--disabled-color)'
                : isThirdElementActive
                  ? 'var(--primary-main-color)'
                  : 'var(--main-font-color)'
            }
            htmlFor={`label-inactive-2-${props.id}`}
            disabled={props.disabled}
            width={widthLabel}
            fontSize={props?.fontSize || DEFAULT_FONT_SIZE}
          >
            {props.labelInactive2}
          </Label>
        </>
      )}
    </div>
  );
};

export default NameSwitcher;
